// extracted by mini-css-extract-plugin
export default {"table_wrapper":"employeesManageSection_table_wrapper__H4B7C"};